import moment from "moment";
import { TimelineOptions } from "vis-timeline/esnext";

export const timelineOptions: TimelineOptions = {
  orientation: "top",
  verticalScroll: true,
  showCurrentTime: false,
  zoomMin: 1000,
  zoomMax: 1000 * 60 * 60 * 24, // 1 day
  maxMinorChars: 7,
  snap: function (date: Date) {
    const resolution = 10; // ms
    return Math.round(date.getTime() / resolution) * resolution;
  },
  moment: (date: moment.MomentInput) => moment(date).utc(),
  format: {
    minorLabels: {
      millisecond: "s.S[s]",
      second: "s[s]",
    },
    majorLabels: {
      second: "HH:mm:ss",
      millisecond: "HH:mm:ss",
    },
  },
  margin: {
    axis: 0,
    item: 0,
  },
  stack: false,
  horizontalScroll: true,
  zoomKey: "shiftKey",
  zoomFriction: 50,
  moveable: true,
};
